export default __webpack_public_path__ + "static/uiux-reimagining-94be234c3cfa304a164eed8f7e49adc8.png";